import React, { useEffect, useState, useRef } from "react";
import {
    Stack,
    Box,
    Button,
    Typography,
    Grid,
    ImageList,
    ImageListItem,
    Divider,
    ImageListItemBar,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Backdrop,
    CircularProgress
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import VideoChatIcon from '@mui/icons-material/VideoChat';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MapIcon from '@mui/icons-material/Map';
import FilePreviewModal from "../tools/Modal";
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ModalInfo from "../tools/ModalInfo";

const live_events_service = require('../../helpers/live_events_service')

const primary = "#8B1A1A";
const primaryLight = "rgba(139,26,26,0.07)";

const Inicio = () => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("sm"));
    const isMd = useMediaQuery(theme.breakpoints.between("sm", "lg"));
    const isLg = useMediaQuery(theme.breakpoints.up("lg"));
    let cols = 4;
    let cols_detalles = 2;
    if (isXs) { cols = 1; cols_detalles = 1; }
    else if (isMd) { cols = 1; cols_detalles = 1; }
    else if (isLg) { cols = 4; cols_detalles = 2; }
    const stats_arr = [
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/9c616b0a-7c5a-4357-9aae-51584e68cb8d.jpeg", title: "ASISTENTES", value: "+250" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/91e32109-0226-4148-8f04-3626d422ad6d.jpeg", title: "STANDS EXPO", value: "+10" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/5bdf2e7f-e34a-42fa-bde3-8965eb1948ce.png", title: "PAÍSES QUE ASISTEN", value: "+20" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/2add16c0-f13c-4879-97a8-5c01f6b07632.jpeg", title: "CONFERENCIAS", value: "+15" }
    ]
    const detalles_arr = [
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d887e158-984e-4537-9d6c-53441c9a2a8a.jpeg", title: "PROGRAMA ACADÉMICO", value: "Click para ver detalles", href: '/programa' },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/933f62f1-b423-4097-8d3f-82b2dd1800b6.jpeg", title: "MEDIA PARTNERS", value: "Click para más detalles", href: '/media-partners' },
    ]
    const varios_arr = [
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/52ae58d7-24cc-4954-ae58-e6a33590d9dd.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/f7bce16e-1a2c-4731-a66b-5a91ecc3eeaa.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d8d7a616-dab4-44e7-853e-0fff815fceeb.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/431f5b17-fa11-4930-b6ef-3f0b1feb573a.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/451f7bb8-1d05-427e-8f18-4e94145c1e86.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/7b9c2c52-6f0d-40e8-acb3-a6d545b2d6a5.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/47129e5f-2a5e-4348-a0d5-752d53d3ecf4.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/620c27f5-eedc-4a94-b052-c3ee2093c749.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/b6010e2c-5019-4bad-b411-bf8cccc61532.jpeg",
    ]
    const [contador] = useState(0);
    const [evento, setEvento] = useState({});
    const [conferencistas, setConferencistas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [url, setUrl] = useState("");
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [info, setInfo] = useState({ conferencista: "", cv: "", foto: "", puesto: "", institucion: "", bandera: "", pais: "" });
    useEffect(() => {
        live_events_service
            .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
            .then((response_evt) => {
                live_events_service
                    .getData(
                        "/patrocinador/view-by-evento/" +
                        process.env.REACT_APP_EVT
                    )
                    .then((response_patrocinador) => {
                        live_events_service
                            .getData(`/conferencista/read/${process.env.REACT_APP_EVT}`)
                            .then((response) => {
                                setEvento(response_evt.data.response_database.result[0]);
                                setLoading(false);
                                setConferencistas([...new Map(response.data.response.result.sort((a, b) => a.hora.localeCompare(b.hora)).map(item => [item.conferencista.nombre, item])).values()].filter((item) => item.conferencista.nombre != 'Representante'))
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            })
            .catch((error) => {
                console.log(error);
            });
    }, [contador]);

    return (
        <Stack>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box
                sx={{
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    color: "#fff",
                    background: `linear-gradient(135deg, ${primary} 0%, #6E1414 55%, #4A0E0E 100%)`,
                    py: { xs: 5, md: 7 },
                    px: { xs: 3, md: 6 },
                    "@keyframes clarHeroIn": {
                        from: { opacity: 0, transform: "translateY(24px)" },
                        to: { opacity: 1, transform: "translateY(0)" },
                    },
                    "@keyframes clarPinPulse": {
                        "0%, 100%": { transform: "scale(1)", opacity: 1 },
                        "50%": { transform: "scale(1.12)", opacity: 0.85 },
                    },
                }}
            >
                {/* Elementos decorativos */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: -90, md: -110 },
                        right: { xs: -90, md: -70 },
                        width: { xs: 220, md: 300 },
                        height: { xs: 220, md: 300 },
                        borderRadius: "50%",
                        border: "2px solid rgba(255,255,255,0.16)",
                        pointerEvents: "none",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        bottom: { xs: -120, md: -150 },
                        left: { xs: -80, md: -50 },
                        width: { xs: 260, md: 360 },
                        height: { xs: 260, md: 360 },
                        borderRadius: "50%",
                        border: "2px solid rgba(255,255,255,0.08)",
                        pointerEvents: "none",
                    }}
                />

                <Stack
                    spacing={{ xs: 3, md: 4 }}
                    alignItems="center"
                    sx={{ position: "relative", zIndex: 1, animation: "clarHeroIn .8s ease both" }}
                >
                    <Typography
                        sx={{
                            textTransform: "uppercase",
                            letterSpacing: { xs: 2, md: 4 },
                            fontSize: { xs: 11, md: 13 },
                            fontWeight: 600,
                            opacity: 0.85,
                            textAlign: "center",
                        }}
                    >
                        CLAR 2026 &middot; XI Congreso Latinoamericano de Riesgos
                    </Typography>

                    <Stack
                        direction={{ xs: "column", md: "row" }}
                        spacing={{ xs: 2.5, md: 4 }}
                        alignItems="stretch"
                        justifyContent="center"
                        sx={{ width: "100%", maxWidth: 860 }}
                    >
                        {/* Fecha */}
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            sx={{
                                flex: 1,
                                backgroundColor: "rgba(255,255,255,0.10)",
                                border: "1px solid rgba(255,255,255,0.25)",
                                borderRadius: 3,
                                px: { xs: 3, md: 4 },
                                py: { xs: 2.25, md: 3 },
                                backdropFilter: "blur(4px)",
                                WebkitBackdropFilter: "blur(4px)",
                                transition: "transform .3s ease, background-color .3s ease",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    backgroundColor: "rgba(255,255,255,0.18)",
                                },
                            }}
                        >
                            <CalendarMonthIcon sx={{ fontSize: { xs: 36, md: 46 } }} />
                            <Box>
                                <Typography
                                    sx={{
                                        textTransform: "uppercase",
                                        letterSpacing: 2,
                                        fontSize: { xs: 10, md: 12 },
                                        fontWeight: 600,
                                        opacity: 0.8,
                                    }}
                                >
                                    Fecha
                                </Typography>
                                <Typography sx={{ fontWeight: "bold", fontSize: { xs: 20, md: 26 }, lineHeight: 1.2 }}>
                                    8 y 9 de octubre
                                </Typography>
                                <Typography sx={{ fontSize: { xs: 12, md: 14 }, opacity: 0.85 }}>
                                    2026
                                </Typography>
                            </Box>
                        </Stack>

                        {/* Hotel sede */}
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            sx={{
                                flex: 1,
                                backgroundColor: "rgba(255,255,255,0.10)",
                                border: "1px solid rgba(255,255,255,0.25)",
                                borderRadius: 3,
                                px: { xs: 3, md: 4 },
                                py: { xs: 2.25, md: 3 },
                                backdropFilter: "blur(4px)",
                                WebkitBackdropFilter: "blur(4px)",
                                transition: "transform .3s ease, background-color .3s ease",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    backgroundColor: "rgba(255,255,255,0.18)",
                                },
                            }}
                        >
                            <LocationOnIcon
                                sx={{ fontSize: { xs: 36, md: 46 }, animation: "clarPinPulse 2.4s ease-in-out infinite" }}
                            />
                            <Box>
                                <Typography
                                    sx={{
                                        textTransform: "uppercase",
                                        letterSpacing: 2,
                                        fontSize: { xs: 10, md: 12 },
                                        fontWeight: 600,
                                        opacity: 0.8,
                                    }}
                                >
                                    Hotel sede
                                </Typography>
                                <Typography sx={{ fontWeight: "bold", fontSize: { xs: 20, md: 26 }, lineHeight: 1.2 }}>
                                    Casa Santo Domingo
                                </Typography>
                                <Typography sx={{ fontSize: { xs: 12, md: 14 }, opacity: 0.85 }}>
                                    Antigua Guatemala
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
            <Box sx={{ width: "100%", padding: '5%' }}>
                <Stack spacing={6}>
                    <Typography variant="h4" align="center" style={{ color: primary, fontWeight: "bold", textAlign: 'center' }}>
                        XI CONGRESO LATINOAMERICANO DE RIESGOS
                    </Typography>
                    <Divider />
                    <Typography
                        variant="h5"
                        sx={{
                            color: primary,
                            fontWeight: "bold",
                            mb: 1,
                            textAlign: "center",
                        }}
                    >
                        Temas del congreso
                    </Typography>
                    <Typography
                        variant="p"
                        sx={{
                            color: primary,
                            fontWeight: 500,
                            textAlign: "center",
                            margin: "0 auto",
                            lineHeight: 1.6
                        }}
                    >
                        RIESGOS OPERACIONALES Y NO FINANCIEROS
                        · CIBERSEGURIDAD Y CONTINUIDAD DE NEGOCIO
                        · GESTIÓN DE RIESGOS FINANCIEROS
                        · CUMPLIMIENTO NORMATIVO Y REGULACIÓN
                        · INTELIGENCIA ARTIFICIAL Y RIESGOS TECNOLÓGICOS
                        · RIESGO DE CRÉDITO, MERCADO Y LIQUIDEZ
                        · SUPERVISIÓN Y REGULACIÓN FINANCIERA
                        · INNOVACIÓN Y TRANSFORMACIÓN DIGITAL EN BANCA
                        · AUDITORÍA INTERNA Y CONTROL
                        · GESTIÓN DE RIESGOS ESG Y SOSTENIBILIDAD
                        · RIESGO DE LAVADO DE DINERO Y CUMPLIMIENTO
                        · PLANIFICACIÓN DE CONTINUIDAD DEL NEGOCIO
                        · GESTIÓN DE CRISIS Y RESILIENCIA INSTITUCIONAL
                        · NUEVAS TECNOLOGÍAS Y FRAUDE DIGITAL
                        · CASOS DE ÉXITO EN ADMINISTRACIÓN DE RIESGOS
                    </Typography>
                </Stack>
            </Box >
            <Box sx={{ width: "100%" }}>
                <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/bff03b26-c16a-4be8-bc37-b717a1319db0.jpeg' style={{ width: '100%' }} loading="lazy" />
            </Box>
            {/* <Box sx={{ display: { xs: 'none', md: 'none', lg: 'block' } }} style={{ width: '100%', padding: '10%', backgroundImage: 'url(https://escuela-bancaria.s3.us-east-2.amazonaws.com/60679408-3bc1-4c8b-b83c-f51f6664d36a.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center', textAlign: 'center' }}>
                <video controls style={{ width: '60%' }} >
                    <source
                        src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/7dcb26b8-3920-4326-838e-d77f0eebcbab.mp4"
                        type="video/mp4"
                    />
                </video>
            </Box>
            <Box sx={{ display: { xs: 'block', md: 'block', lg: 'none' } }} style={{ width: '100%', padding: '10%', backgroundImage: 'url(https://escuela-bancaria.s3.us-east-2.amazonaws.com/60679408-3bc1-4c8b-b83c-f51f6664d36a.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center', textAlign: 'center' }}>
                <video controls style={{ width: '100%' }} >
                    <source
                        src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/7dcb26b8-3920-4326-838e-d77f0eebcbab.mp4"
                        type="video/mp4"
                    />
                </video>
            </Box>*/}
            <Box sx={{ width: "100%", padding: '5%' }}>
                <Stack spacing={6}>
                    <Typography
                        variant="h5"
                        align="center"
                        style={{ color: primary, fontWeight: "bold", textAlign: 'center' }}
                    >
                        ¿Cómo anticipar y gestionar los riesgos que definirán el futuro financiero de la región?
                    </Typography>

                    <Typography
                        variant="p"
                        align="center"
                        style={{ color: primary, fontWeight: "bold", textAlign: 'justify' }}
                    >
                        La evolución tecnológica, los cambios regulatorios y el entorno macroeconómico están redefiniendo la forma en que las instituciones financieras identifican, evalúan y mitigan sus riesgos.

                        Hoy, las áreas de gestión de riesgos, auditoría, cumplimiento normativo y alta dirección enfrentan un reto clave: evolucionar de funciones reactivas a arquitectos estratégicos de la resiliencia institucional.

                        CLAR 2026 reúne a los líderes que están marcando el rumbo en la región: directores de riesgos, gerentes de auditoría, responsables de cumplimiento, reguladores y supervisores financieros del sector bancario y financiero de América Latina.

                        Durante dos días intensivos:

                        Descubrirás cómo la inteligencia artificial está transformando la gestión de riesgos operacionales y financieros

                        Analizarás los retos de la ciberseguridad, el fraude digital y la continuidad del negocio

                        Aprenderás a navegar el entorno regulatorio y de cumplimiento normativo en la región

                        Conocerás estrategias reales de gestión de crisis, resiliencia y sostenibilidad

                        Conectarás con expertos locales e internacionales de reconocido prestigio en el sector financiero

                        CLAR no es solo un congreso.
                        Es el espacio donde el conocimiento técnico y la visión estratégica se convierten en la ventaja competitiva de las instituciones financieras.

                        Porque en un entorno que cambia constantemente, la pregunta no es si debes transformarte.
                        La pregunta es: ¿tu institución está preparada para liderar el futuro?
                    </Typography>
                </Stack>
            </Box>
            <ImageList cols={cols}>
                {stats_arr.map((item) => (
                    <ImageListItem key={item.img}>
                        <img
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                        />
                        <ImageListItemBar
                            title={item.title}
                            subtitle={item.value}
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <Grid container alignItems="center" justifyContent="center" style={{ textAlign: "justify", width: '100%' }}>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ padding: { xs: '5%', md: '8%', lg: '10%' } }} style={{ backgroundColor: primary }}>
                    <Stack spacing={2} >
                        <Typography variant="h4" align="center" style={{ color: "white", fontWeight: "bold", textAlign: 'justify' }}>
                            Precio Especial por Grupos
                        </Typography>
                        <Typography
                            variant="p"
                            align="center"
                            style={{ color: "white", fontWeight: "bold", textAlign: 'justify' }}
                        >
                            Reserva para ti y tu equipo el acceso a CLAR 2026 con un precio especial para grupos de 3 o más personas.
                            Asegura tu lugar en el congreso líder en gestión de riesgos financieros, cumplimiento normativo e innovación en el sector bancario de la región.
                        </Typography>
                        <List style={{ color: 'white' }}>
                            <ListItem disablePadding>
                                <ListItemButton href={
                                    process.env.REACT_APP_URL_INSCRIPCION +
                                    process.env.REACT_APP_EVT
                                } target="_blank">
                                    <ListItemIcon>
                                        <ShoppingCartIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Comprar" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20tarifa%20grupal%20de%20CLAR%202026">
                                    <ListItemIcon>
                                        <InfoIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Solicitar más información" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="https://ebg.edu.gt" target="_blank">
                                    <ListItemIcon>
                                        <VideoChatIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinar Open House CLAR 2026" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ padding: { xs: '5%', md: '8%', lg: '10%' } }}>
                    <Stack spacing={2} >
                        <Typography variant="h4" align="center" style={{ color: primary, fontWeight: "bold", textAlign: 'justify' }}>
                            Patrocinio
                        </Typography>
                        <Typography variant="p" align="center" style={{ color: primary, fontWeight: "bold", textAlign: 'justify' }}>
                            Reserva una de las posiciones disponibles
                        </Typography>
                        <Typography variant="h5" align="center" style={{ color: primary, fontWeight: "bold", textAlign: 'justify' }}>
                            Patrocinador / Stand / Speaker
                        </Typography>
                        <List style={{ color: primary }}>
                            <ListItem disablePadding>
                                <ListItemButton
                                    onClick={() => { setOpen(true); setUrl(evento.evt_info_pdf) }}
                                >
                                    <ListItemIcon>
                                        <PictureAsPdfIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Ver Brief de Patrocinios" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton
                                    onClick={() => { setOpen(true); setUrl(evento.planos) }}
                                >
                                    <ListItemIcon>
                                        <MapIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Ver Planos de Expo" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20patrocinio%20de%20CLAR%202026">
                                    <ListItemIcon>
                                        <InfoIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Solicitar más información" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <VideoChatIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinar Open House CLAR 2026 - Sponsors" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Stack>
                </Grid>
            </Grid>
            <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/32822687-28f8-4c65-ab50-d9d02afe62af.jpeg' style={{ width: '100%' }} />
            <Box
                sx={{
                    width: "100%",
                    height: "600px",
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/53a78163-a027-4504-833e-91fb7b69d022.jpeg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)",
                        backgroundColor: "rgba(0,0,0,0.4)",
                        zIndex: 1,
                    }}
                />
                <Box sx={{ position: "relative", zIndex: 2 }} p={15}>
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            DIRIGIDO A:
                        </Typography>
                        <Typography
                            variant="P"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            Sector Financiero y No Financiero
                        </Typography>
                        <Typography
                            variant="p"
                            color="white"
                            sx={{ maxWidth: "600px", opacity: 0.9 }}
                            gutterBottom
                            style={{ textAlign: 'justify' }}
                        >
                            Dirigido a altos directivos de las áreas de gestión de riesgos financieros (auditoría, crédito, mercado, liquidez) y no financieros (operativo, ciberseguridad), así como responsables en áreas de planeación financiera, tesorería y nuevos negocios en entidades bancarias, microfinancieras, cooperativas, cajas de ahorro y sector empresarial. También para reguladores y supervisores financieros, entidades multilaterales, gremios económicos y todo profesional interesado en la administración estratégica de riesgos del ecosistema financiero de América Latina.
                        </Typography>
                    </Stack>
                </Box>
            </Box>
            <ImageList cols={cols_detalles}>
                {detalles_arr.map((item) => (
                    <ImageListItem key={item.img}>
                        <img
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                            style={{ height: '500px', objectFit: 'cover' }}
                        />
                        <ImageListItemBar
                            title={item.title}
                            subtitle={item.value}
                            actionIcon={
                                <IconButton
                                    sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                    aria-label={`info about ${item.title}`}
                                    href={item.href}
                                >
                                    <InfoIcon />
                                </IconButton>
                            }
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <Box
                sx={{
                    width: "100%",
                    height: "600px",
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/2cdb630b-7fe3-43ec-a0fe-10288be8da1a.jpeg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)",
                        backgroundColor: "rgba(0,0,0,0.4)",
                        zIndex: 1,
                    }}
                />
                <Box sx={{ position: "relative", zIndex: 2 }} p={15}>
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            CLAR 2026
                        </Typography>

                        <Typography
                            variant="P"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                        >
                            +20 expositores
                        </Typography>

                        <Typography
                            variant="p"
                            color="white"
                            sx={{ maxWidth: "600px", opacity: 0.9 }}
                            gutterBottom
                            style={{ textAlign: 'justify' }}
                        >
                            Conferencias magistrales, paneles especializados y espacios de networking estratégico sobre gestión de riesgos operacionales y financieros, ciberseguridad, cumplimiento normativo, inteligencia artificial aplicada a riesgos y los desafíos que plantea la evolución tecnológica para las instituciones financieras de América Latina.

                            Conecta con expertos locales e internacionales de reconocido prestigio en el sector bancario y financiero y lleva la gestión de riesgos de tu institución al siguiente nivel.
                        </Typography>
                    </Stack>
                </Box>
            </Box>

            {conferencistas.length > 0 && (
                <Box sx={{ width: "100%", padding: '5%', overflow: 'hidden' }}>
                    <Stack spacing={6}>
                        <Typography variant="h4" align="center" style={{ color: primary, fontWeight: "bold", textAlign: 'center' }}>
                            NUESTROS CONFERENCISTAS
                        </Typography>
                        <Divider />
                        <ImageList cols={cols}>
                            {conferencistas.map((item) => (
                                <ImageListItem
                                    key={item.conferencista.foto_alt}
                                    sx={{
                                        borderRadius: 3,
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        position: "relative",
                                        transition: "box-shadow 0.3s ease",
                                        "&:hover": {
                                            boxShadow: `0 0 20px ${primary}`,
                                        },
                                        "&:hover img": {
                                            filter: "brightness(1.05)",
                                        },
                                    }}
                                >
                                    <img
                                        srcSet={`${item.conferencista.foto_alt}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                        src={`${item.conferencista.foto_alt}?w=248&fit=crop&auto=format`}
                                        alt={item.conferencista.nombre}
                                        loading="lazy"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                            transition: "filter 0.3s ease",
                                            filter: "grayscale(100%)",
                                        }}
                                        onMouseEnter={(e) =>
                                            (e.currentTarget.style.filter = "grayscale(0%)")
                                        }
                                        onMouseLeave={(e) =>
                                            (e.currentTarget.style.filter = "grayscale(100%)")
                                        }
                                    />

                                    <ImageListItemBar
                                        title={item.conferencista.nombre}
                                        sx={{
                                            background:
                                                "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2))",
                                        }}
                                        actionIcon={item.conferencista.cv &&
                                            <IconButton
                                                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                                aria-label={`info about ${item.title}`}
                                                onClick={() => {
                                                    setInfo({ conferencista: item.conferencista.nombre, cv: item.conferencista.cv, foto: item.conferencista.foto_alt, puesto: item.conferencista.puesto, institucion: item.conferencista.institucion, bandera: item.conferencista.bandera, pais: item.conferencista.pais })
                                                    setModalOpen(true);
                                                }}
                                            >
                                                <InfoIcon />
                                            </IconButton>
                                        }
                                    />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </Stack>
                </Box >
            )}
            <ImageList variant="woven" cols={3} gap={8}>
                {varios_arr.map((item) => (
                    <ImageListItem key={item}>
                        <img
                            srcSet={`${item}?w=161&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item}?w=161&fit=crop&auto=format`}
                            alt={"varios"}
                            loading="lazy"
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <FilePreviewModal open={open} onClose={() => setOpen(false)} url={url} title="Vista previa" />
            <ModalInfo open={modalOpen} onClose={() => { setModalOpen(false) }} conferencista={info} />
        </Stack >
    );
};

export default Inicio;
